import { useEffect, useState } from "react";
import { History, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const KEY = "adm:new-site-draft:v1";
export const clearDraft = () => { try { localStorage.removeItem(KEY); } catch { /* storage unavailable */ } };

// Wizard autosave in this browser (files excluded: they must be re-attached). Offers to resume after leaving the page.
export function useWizardDraft(form, step, restore) {
  const [found, setFound] = useState(() => { try { return JSON.parse(localStorage.getItem(KEY) || "null"); } catch { return null; } });
  const [armed, setArmed] = useState(!found);
  useEffect(() => {
    if (!armed) return undefined;
    const t = setTimeout(() => { try { const { files, ...rest } = form; localStorage.setItem(KEY, JSON.stringify({ form: rest, step, at: new Date().toISOString(), files: files.length })); } catch { /* quota */ } }, 400);
    return () => clearTimeout(t);
  }, [form, step, armed]);
  const resume = () => { restore(found.form, found.step); setFound(null); setArmed(true); };
  const discard = () => { clearDraft(); setFound(null); setArmed(true); };
  return { found, resume, discard };
}

export function DraftBanner({ draft }) {
  const d = draft.found;
  if (!d) return null;
  const what = [d.form?.client_id && d.form?.company_name, d.form?.name].filter(Boolean).join(" · ") || "senza nome";
  return (
    <div className="mt-6 flex flex-wrap items-center gap-3 rounded-xl border border-sky-200 bg-sky-50/70 p-3 text-sm text-slate-700" data-testid="wizard-draft-banner">
      <History size={16} className="text-sky-700" />
      <span className="min-w-0 flex-1">Hai un brief non completato: <b>{what}</b> ({new Date(d.at).toLocaleString("it-IT")}){d.files ? ` · ${d.files} file da ricaricare` : ""}.</span>
      <Button size="sm" className="bg-sky-600 hover:bg-sky-700" onClick={draft.resume} data-testid="wizard-draft-resume">Riprendi</Button>
      <Button size="sm" variant="ghost" onClick={draft.discard} data-testid="wizard-draft-discard"><X size={14} className="mr-1" />Ricomincia</Button>
    </div>);
}
